module.exports = __webpack_public_path__ + "static/media/16UNODC12.b2f305fa.jpg";